<div class="main-grid">
  <h2 mat-dialog-title>{{ 'ORDERS.IMPORT.add_orders' | translate }}</h2>
  <mat-dialog-content>
    <form [formGroup]="form" class="form-grid">
      <app-select formControlName="courier">
        <app-select-label>{{ 'ORDERS.COMMON.UNLOADING.courier_tooltip' | translate }}</app-select-label>
        @for (courier of couriers; track courier) {
          <mat-option [value]="courier.id">{{ courier.name }}</mat-option>
        }
      </app-select>

      <app-select formControlName="sender">
        <app-select-label>{{ 'ORDERS.COMMON.UNLOADING.sender_tooltip' | translate }}</app-select-label>
        @for (sender of senders; track sender) {
          <mat-option [value]="sender.id">
            {{ sender.name }}
          </mat-option>
        }
      </app-select>
    </form>

    <app-button-group>
      <button (click)="clearFile()" color="warn" mat-button>
        <mat-label>{{ 'ORDERS.IMPORT.clear' | translate }}</mat-label>
        <mat-icon>close</mat-icon>
      </button>

      <button (click)="input.click()"
        [disabled]="form.invalid"
        color="primary"
        mat-button>
        <mat-label>{{ 'ORDERS.IMPORT.choose_file' | translate }}</mat-label>
        @if (!ordersInput.length) {
          <mat-icon style="margin-left: 5px;">publish</mat-icon>
        }
        @if (ordersInput.length) {
          <mat-icon style="margin-left: 5px;">description</mat-icon>
        }
      </button>
      <input #input
        (change)="addNewFile($event.target.files[0], input)"
        hidden
        accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel.sheet.macroEnabled.12"
        type="file">
    </app-button-group>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button type="button" mat-button mat-dialog-close>
      <mat-label>{{ 'COMMON.cancel' | translate }}</mat-label>
    </button>

    <button [mat-dialog-close]="ordersInput.length && ordersInput"
      [disabled]="form.invalid || !ordersInput.length || ordersInput.length > 100"
      color="primary"
      mat-raised-button>
      <mat-label>{{ 'COMMON.add' | translate }}</mat-label>
    </button>
  </mat-dialog-actions>
</div>
